import React from 'react';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import Call from '../../components/Call';

const Contact = props => (
  <Layout bodyClass="page-contact">
    <SEO title="Contact" />
    <div className="intro intro-small">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>Our Privacy Policy</h1>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-12">
          <Call button={false} />
        </div>


        <div className="col-12 pt-5">
        OneAction NZ collects personal information from you, including your:
           <ul>
               <li>
               Name
               </li>
               <li>
               Contact information
               </li>
           </ul>
           We collect your personal information in order to:
           <ul>
               <li>
               Contact you about OneAction
               </li>
               <li>
               Provide access to OneAction services or websites
               </li>
           </ul>
           You have the right to ask for a copy of any personal information we hold about you, and to ask for it to be corrected if you think it is wrong. If you’d like to ask for a copy of your information, or to have it corrected, please contact us at info@team.oneaction.nz
        </div>
      </div> 
    </div>
  </Layout>
);

export default Contact;
